// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DisplayPreferencesController from "./display_preferences_controller"
application.register("display-preferences", DisplayPreferencesController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import EditorModeToggleController from "./editor_mode_toggle_controller"
application.register("editor-mode-toggle", EditorModeToggleController)

import MilkdownController from "./milkdown_controller"
application.register("milkdown", MilkdownController)

import NoteController from "./note_controller"
application.register("note", NoteController)

import PageTagPickerController from "./page_tag_picker_controller"
application.register("page-tag-picker", PageTagPickerController)

import PageSummaryGeneratorController from "./page_summary_generator_controller"
application.register("page-summary-generator", PageSummaryGeneratorController)

import TagSchemaBuilderController from "./tag_schema_builder_controller"
application.register("tag-schema-builder", TagSchemaBuilderController)

import TimezoneFormatterController from "./timezone_formatter_controller"
application.register("timezone-formatter", TimezoneFormatterController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import PagePhotoDropController from "./page_photo_drop_controller"
application.register("page-photo-drop", PagePhotoDropController)

import PagePhotoLightboxController from "./page_photo_lightbox_controller"
application.register("page-photo-lightbox", PagePhotoLightboxController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import OverflowToolbarController from "./overflow_toolbar_controller"
application.register("overflow-toolbar", OverflowToolbarController)
